var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NodeSelection } from 'prosemirror-state';
var getMarkDisable = function (excludeMarks, markName) {
    if (!excludeMarks)
        return false;
    if (excludeMarks === '_')
        return true;
    if (excludeMarks.split(/\s/).includes(markName))
        return true;
    return false;
};
var checkMarkDisable = function (view, markName) {
    var $from = view.state.selection.$from;
    if ($from.parent.type.spec.code)
        return true;
    var excludeMarks = $from.parent.type.spec.excludeMarks;
    if (!getMarkDisable(excludeMarks, markName)) {
        if ($from.depth > 1) {
            var parentExcludeMarks = $from.node($from.depth - 1).type.spec.excludeMarks;
            return getMarkDisable(parentExcludeMarks, markName);
        }
        return false;
    }
    return true;
};
var checkSupportAttr = function (node, attrName) { return node.attrs[attrName] !== undefined; };
var checkParentSupportAttr = function (view, attrName) {
    var selection = view.state.selection;
    if (selection instanceof NodeSelection) {
        return checkSupportAttr(selection.node, attrName);
    }
    var $from = selection.$from, $to = selection.$to;
    var isSupport = checkSupportAttr(selection.$from.node(), attrName);
    if (!isSupport && $from.nodeAfter && $from.pos === $to.pos) {
        isSupport = checkSupportAttr($from.nodeAfter, attrName);
    }
    return isSupport;
};
var setAlign = function (view, align) {
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr;
    var ranges = state.selection.ranges;
    if (!ranges.length)
        return false;
    ranges.forEach(function (range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        state.doc.nodesBetween(from, to, function (node, nodePos) {
            if (node.isTextblock || node.attrs.align !== undefined) {
                tr.setNodeMarkup(nodePos, undefined, __assign(__assign({}, node.attrs), { align: align }));
                return false;
            }
        });
    });
    dispatch(tr);
    return true;
};
var checkParentHaveAttr = function (view, attrName, attrVal) {
    return view.state.selection.$from.parent.attrs[attrName] === attrVal;
};
// add user configuration to attrs attribute
var addAttrsByConfig = function (config, schema) {
    if (config === void 0) { config = {}; }
    if (!schema.attrs)
        schema.attrs = {};
    Object.keys(config).forEach(function (name) {
        Object.keys(config[name]).forEach(function (spec) {
            if (spec === 'getFromDOM' || spec === 'setDOMAttr')
                return;
            if (!schema.attrs[name])
                schema.attrs[name] = {};
            schema.attrs[name][spec] = config[name][spec];
        });
    });
};
// uses the default value when return undefined
var getFromDOMByConfig = function (config, dom, parseAttrs) {
    if (config === void 0) { config = {}; }
    return Object.keys(config).forEach(function (name) {
        var _a;
        var value = config[name].getFromDOM(dom);
        if (value !== undefined)
            Object.assign(parseAttrs, (_a = {}, _a[name] = value, _a));
    });
};
// used to construct dom in `toDOM`
var setDOMAttrByConfig = function (config, node, attrs) {
    if (config === void 0) { config = {}; }
    return Object.keys(config).forEach(function (name) { return config[name].setDOMAttr(node.attrs[name], attrs); });
};
// Keep the decimal point
var getFixSize = function (num, count) {
    if (count === void 0) { count = 3; }
    return Number(num.toFixed(count).replace(/\.?0+$/, ''));
};
var createFileInput = function (_a) {
    var _b = _a.multiple, multiple = _b === void 0 ? false : _b, accept = _a.accept, onChange = _a.onChange, _c = _a.getContainer, getContainer = _c === void 0 ? function () { return document.body; } : _c;
    var input = document.createElement('input');
    input.type = 'file';
    input.multiple = multiple;
    input.accept = accept;
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
        onChange(e);
        e.target.value = '';
    });
    getContainer().appendChild(input);
    return input;
};
var isMatchObject = function (objStatic, objCompare) {
    if (objStatic === objCompare)
        return true;
    if (!(objStatic && typeof objStatic === 'object') || !(objCompare && typeof objCompare === 'object'))
        return false;
    var isArray = Array.isArray(objStatic);
    if (Array.isArray(objCompare) !== isArray)
        return false;
    if (isArray) {
        if (objStatic.length !== objCompare.length)
            return false;
        for (var i = 0; i < objStatic.length; i++)
            if (!isMatchObject(objStatic[i], objCompare[i]))
                return false;
    }
    else {
        for (var p in objStatic)
            if (!(p in objCompare) || !isMatchObject(objStatic[p], objCompare[p]))
                return false;
    }
    return true;
};
var keymapToggleMark = function (name) { return function (editor) {
    var _a;
    var isActive = editor.isActive(name);
    editor.setFormat((_a = {}, _a[name] = !isActive, _a));
    return true;
}; };
export { addAttrsByConfig, checkMarkDisable, checkParentHaveAttr, checkParentSupportAttr, createFileInput, getFixSize, getFromDOMByConfig, getMarkDisable, isMatchObject, keymapToggleMark, setAlign, setDOMAttrByConfig, };
//# sourceMappingURL=tools.js.map